import StoreManager from "../appdata";
import Helpers from "../helpers";
import { screenIDState } from "../helpers";
import { Buffer } from 'buffer';
import TrueID from '../index'
import { generateHMAC, getNonce, sampleString } from "../helpers/cryptoUtils";
// import crypto from 'crypto-browserify';

export const getAccessToken = (type = "ekyc") => {
  const config =
    type === "face_authen"
      ? StoreManager.appdata.configFaceAuthen
      : type === "face_enroll"
      ? StoreManager.appdata.configFaceEnroll
      : StoreManager.appdata.configEkyc;

    console.log("config", config)
  if (config.accessToken && config.accessToken !== '') {
    StoreManager.appdata.accessToken = config.accessToken;
    callCreateRequest(type);
    return;
  }

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    client_id: config.clientId,
    client_secret: config.clientSecret,
    grant_type: "client_credentials",
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(`${config.domain}${config.configEndpoint?.accesstoken || config.accesstokenEndPoint}`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if (result.access_token) {
        StoreManager.appdata.accessToken = result.access_token;
        callCreateRequest(type);
      } else {
        console.error("❌ getAccessToken: No access_token returned", result);
      }
    })
    .catch((error) => console.error("❌ getAccessToken error:", error));
};


export const callCreateRequest = (type = "ekyc") => {
  const config =
    type === "face_authen"
      ? StoreManager.appdata.configFaceAuthen
      : type === "face_enroll"
      ? StoreManager.appdata.configFaceEnroll
      : StoreManager.appdata.configEkyc;

  if (config.requestId && config.requestId !== '') {
    StoreManager.appdata.requestId = config.requestId;
    return;
  }

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", config.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);

  if (config.configHeader) {
    try {
      const configHeader = JSON.parse(config.configHeader);
      Object.keys(configHeader).forEach((key) => {
        myHeaders.append(key, configHeader[key]);
      });
    } catch (e) {
      console.warn("⚠️ Invalid configHeader JSON:", e);
    }
  }

  const raw = JSON.stringify({
    platform: StoreManager.userdata.platform,
    device_id: StoreManager.userdata.device_id,
    os_version: StoreManager.userdata.os_version,
    app_version: StoreManager.userdata.app_version,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(`${config.domain}${config.configEndpoint?.createrequest || config.createRequestEndPoint}`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if(type == "ekyc"){
        if (result.request_id) {
          StoreManager.appdata.requestId = result.request_id;
        } else {
          console.error("❌ callCreateRequest: No request_id returned", result);
        }
      } else {
        if (result.requestId) {
          StoreManager.appdata.requestId = result.requestId;
        } else {
          console.error("❌ callCreateRequest: No requestId returned", result);
        }
      }
      
    })
    .catch((error) => console.error("❌ callCreateRequest error:", error));
};


Array.prototype.removeByValue = function (val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] === val) {
      this.splice(i, 1);
      i--;
    }
  }
  return this;
}

export const callAPIFront = (id_card) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", StoreManager.appdata.configEkyc.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  if (StoreManager.appdata.configEkyc.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configEkyc.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }
  StoreManager.appdata.rawImage.front = id_card
  const raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "device_model": "",
    "platform": StoreManager.userdata.platform,
    "device_id": StoreManager.userdata.device_id,
    "app_version":StoreManager.userdata.app_version,
    "os_version": StoreManager.userdata.os_version,
    "image_id": "image_id",
    "id_card": id_card
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  // fetch("/api/ekyc/v1.2/id/verify/front", requestOptions)
  fetch(`${StoreManager.appdata.configEkyc.domain}${StoreManager.appdata.configEkyc.configEndpoint.front}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      StoreManager.appdata.sdkHistories.push({
        path: StoreManager.appdata.configEkyc.configEndpoint.front,
        body: raw,
        result: result
      })
      if (result.result == 1) {

        if (result.attributes.id_type.type == 2) { // check giấy tờ có là hộ chiếu không nếu có bỏ qua bước chụp mặt sau
          StoreManager.appdata.configEkyc.stepVerification.removeByValue("BACK")
        }

        StoreManager.appdata.thisFront.updateSuccess()
        // StoreManager.appdata.thisApp.nextStep()
      } else {
        let error = Helpers.errorByCode(result.result)
        console.log("result.result",result.result)
        StoreManager.appdata.thisFront.setState({ status: screenIDState.CALL_API_FAILED, errorMessage: error.message })

        if(StoreManager.appdata.thisFront.countCallAPI >=  StoreManager.appdata.configEkyc.maxRetry){
           setTimeout(async () => {
                await  StoreManager.stopStream()
                StoreManager.appdata.callback({code: 302,errorMessage: "Trueid Locked",  clientId: StoreManager.appdata.configEkyc.clientId,
                                  requestId: StoreManager.appdata.requestId,
                                  deviceId: StoreManager.userdata.device_id,
                                  rawImage: StoreManager.appdata.rawImage,
                                  sdkHistories:  StoreManager.appdata.sdkHistories,})
                TrueID.close()
          }, 100)
        }
      }
    })
    .catch((error) => console.error(error));
}

export const callAPIBack = (id_card) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", StoreManager.appdata.configEkyc.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  if (StoreManager.appdata.configEkyc.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configEkyc.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }
  StoreManager.appdata.rawImage.back = id_card

  const raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "device_model": "",
    "platform": StoreManager.userdata.platform,
    "device_id": StoreManager.userdata.device_id,
    "app_version":StoreManager.userdata.app_version,
    "os_version": StoreManager.userdata.os_version,
    "image_id": "image_id",
    "id_card": id_card
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  // fetch("/api/ekyc/v1.2/id/verify/back", requestOptions)
  fetch(`${StoreManager.appdata.configEkyc.domain}${StoreManager.appdata.configEkyc.configEndpoint.back}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      // console.log("result", result)
      StoreManager.appdata.sdkHistories.push({
        path: StoreManager.appdata.configEkyc.configEndpoint.back,
        body: raw,
        result: result
      })
      if (result.result == 1) {
        StoreManager.appdata.thisBack.updateSuccess()

      } else {
        let error = Helpers.errorByCode(result.result)
        StoreManager.appdata.thisBack.setState({ status: screenIDState.CALL_API_FAILED, errorMessage: error.message })
        
        if(StoreManager.appdata.thisBack.countCallAPI >=  StoreManager.appdata.configEkyc.maxRetry){
          StoreManager.appdata.callback({code: 302,errorMessage: "Trueid Locked", clientId: StoreManager.appdata.configEkyc.clientId,
                            requestId: StoreManager.appdata.requestId,
                            deviceId: StoreManager.userdata.device_id,
                            rawImage: StoreManager.appdata.rawImage,
                            sdkHistories:  StoreManager.appdata.sdkHistories,})
           setTimeout(async () => {
                await  StoreManager.stopStream()
                TrueID.close()
            }, 100)
        }
      }
    })
    .catch((error) => console.error(error));
}


export const callAPIOcr = () => {
  const myHeaders = new Headers();
  myHeaders.append("ClientID", StoreManager.appdata.configEkyc.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  myHeaders.append("Content-Type", "application/json");
  if (StoreManager.appdata.configEkyc.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configEkyc.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }

  const raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "device_model": "",
    "platform": StoreManager.userdata.platform,
    "device_id": StoreManager.userdata.device_id,
    "app_version":StoreManager.userdata.app_version,
    "os_version": StoreManager.userdata.os_version,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  // fetch("/api/ekyc/v1.2/id/ocr", requestOptions)
  fetch(`${StoreManager.appdata.configEkyc.domain}${StoreManager.appdata.configEkyc.configEndpoint.ocr}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      // console.log("/api/ekyc/v1.2/id/ocr", result)
      if (result.result == 1) {
        StoreManager.appdata.thisOcr.setState({
          fullName: result.data_fields?.name?.value,
          dateOfBirth: result.data_fields?.dob?.value,
          gender: result.data_fields?.gender?.value,
          idNumber: result.data_fields?.id_number?.value,
          givenDate: result.data_fields?.given_date?.value,
          dueDate: result.data_fields?.due_date?.value,
          placeOfIssue: result.data_fields?.given_place?.value,
          permanentAddress: result.data_fields?.id_address?.value
        })
      }

    })
    .catch((error) => console.error(error));
}

export const callAPIOcr2 = () => {
  const myHeaders = new Headers();
  myHeaders.append("ClientID", StoreManager.appdata.configEkyc.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  myHeaders.append("Content-Type", "application/json");
  if (StoreManager.appdata.configEkyc.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configEkyc.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }

  const raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "device_model": "",
    "platform": StoreManager.userdata.platform,
    "device_id": StoreManager.userdata.device_id,
    "app_version":StoreManager.userdata.app_version,
    "os_version": StoreManager.userdata.os_version,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  // fetch("/api/ekyc/v1.2/id/ocr", requestOptions)
  fetch(`${StoreManager.appdata.configEkyc.domain}${StoreManager.appdata.configEkyc.configEndpoint.ocr}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      // console.log("/api/ekyc/v1.2/id/ocr", result)
        

    })
    .catch((error) => console.error(error));
}

export const callAPISelfie = (selfie) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", StoreManager.appdata.configEkyc.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  if (StoreManager.appdata.configEkyc.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configEkyc.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }

  StoreManager.appdata.rawImage.selfie = selfie

  const raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "device_model": "device_model",
    "platform": "web",
    "device_id": StoreManager.userdata.device_id,
    "app_version":StoreManager.userdata.app_version,
    "os_version": StoreManager.userdata.os_version,
    "image_id": "image_id",
    "selfie": selfie
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  fetch(`${StoreManager.appdata.configEkyc.domain}${StoreManager.appdata.configEkyc.configEndpoint.selfie}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      // console.log(result)
      if (result.result == 1) {
        StoreManager.appdata.thisSelfie.updateSuccess()
      } else {
        let error = Helpers.errorByCode(result.result)
        StoreManager.appdata.thisSelfie.setState({ status: screenIDState.CALL_API_FAILED, errorMessage: error.message })
       
        if(StoreManager.appdata.thisSelfie.countCallAPI >=  StoreManager.appdata.configEkyc.maxRetry){
          StoreManager.appdata.callback({code: 302,errorMessage: "Trueid Locked",  clientId: StoreManager.appdata.configEkyc.clientId,
                            requestId: StoreManager.appdata.requestId,
                            deviceId: StoreManager.userdata.device_id,
                            rawImage: StoreManager.appdata.rawImage,
                            sdkHistories:  StoreManager.appdata.sdkHistories,})
           setTimeout(async () => {
              await  StoreManager.stopStream()
              TrueID.close()
          }, 100)
        }
      }
    })
    .catch((error) => console.error(error));
}

export const callAPISelfie2 = async (selfie, selfie2) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", StoreManager.appdata.configEkyc.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  if (StoreManager.appdata.configEkyc.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configEkyc.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }

  var raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "device_model": "device_model",
    "platform": "web",
    "device_id": StoreManager.userdata.device_id,
    "app_version":StoreManager.userdata.app_version,
    "os_version": StoreManager.userdata.os_version,
    "image_id": "image_id",
    "faceImages": [selfie, selfie2]
  });
console.log("StoreManager.appdata.configEkyc.sdkKey", StoreManager.appdata.configEkyc.sdkKey)
  if(StoreManager.appdata.configEkyc.sdkKey != ''){
    
    let nonce = getNonce(StoreManager.appdata.accessToken)
    let face1_32 = sampleString(selfie)
    let face2_32 = sampleString(selfie2)
    let signature = await generateHMAC(nonce, face1_32, face2_32)
    raw = JSON.stringify({
      "request_id": StoreManager.appdata.requestId,
      "device_model": "device_model",
      "platform": "web",
      "device_id": StoreManager.userdata.device_id,
      "app_version":StoreManager.userdata.app_version,
      "os_version": StoreManager.userdata.os_version,
      "image_id": "image_id",
      "faceImages": [selfie, selfie2],
      "apiVersion":1,
      "signature": signature,
      "nonce": nonce
    });
  }


  StoreManager.appdata.rawImage.selfie = selfie

 

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  fetch(`${StoreManager.appdata.configEkyc.domain}${StoreManager.appdata.configEkyc.configEndpoint.selfie}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      // console.log(result)
      StoreManager.appdata.sdkHistories.push({
        path: StoreManager.appdata.configEkyc.configEndpoint.selfie,
        body: raw,
        result: result
      })
      if (result.result == 1) {
        StoreManager.appdata.thisSelfie.updateSuccess()
      } else {
        let error = Helpers.errorByCode(result.result)
        StoreManager.appdata.thisSelfie.updateError() //.setState({ status: screenIDState.CALL_API_FAILED, errorMessage: error.message })
        
        // console.log("StoreManager.appdata.configEkyc.maxRetry", StoreManager.appdata.configEkyc.maxRetry)
        // console.log("StoreManager.appdata.thisSelfie.countCallAPI", StoreManager.appdata.thisSelfie.countCallAPI)
        if(StoreManager.appdata.thisSelfie.countCallAPI >=  StoreManager.appdata.configEkyc.maxRetry){
          StoreManager.appdata.callback({code: 302,errorMessage: "Trueid Locked", clientId: StoreManager.appdata.configEkyc.clientId,
                            requestId: StoreManager.appdata.requestId,
                            deviceId: StoreManager.userdata.device_id,
                            rawImage: StoreManager.appdata.rawImage,
                            sdkHistories:  StoreManager.appdata.sdkHistories,})
          setTimeout(async () => {
              await  StoreManager.stopStream()
              TrueID.close()
          }, 100)
        }
      }
    })
    .catch((error) => console.error(error));
}

export const callAPIComplete = () => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  myHeaders.append("ClientID", StoreManager.appdata.configEkyc.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  if (StoreManager.appdata.configEkyc.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configEkyc.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }

  const raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "device_id": StoreManager.userdata.device_id,
    "app_version":StoreManager.userdata.app_version,
    "os_version": StoreManager.userdata.os_version,
    "platform": StoreManager.userdata.platform,
    "pull_ekyc_result": 1,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };
  if(StoreManager.appdata.configEkyc.configEndpoint.complete == ""){
    let sdkResult = {
      code: 1,
      errorMessage: "",
      clientId: StoreManager.appdata.configEkyc.clientId,
      requestId: StoreManager.appdata.requestId,
      deviceId: StoreManager.userdata.device_id,
      rawImage: StoreManager.appdata.rawImage,
        editOCR:StoreManager.appdata.editOCR,
      sdkHistories:  StoreManager.appdata.sdkHistories
    }
    StoreManager.appdata.callback(sdkResult)
    setTimeout(async () => {
      await  StoreManager.stopStream()
       TrueID.close()
   }, 100)
  } else {
  // fetch("/api/ekyc/v1.2/complete", requestOptions)
  fetch(`${StoreManager.appdata.configEkyc.domain}${StoreManager.appdata.configEkyc.configEndpoint.complete}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      // Helpers.loading.hideLoadingSpinner()

      // console.log("/api/ekyc/v1.2/complete", result)
      let sdkResult = {
        code: 1,
        errorMessage: "",
        clientId: result.client_id,
        requestId: result.request_id,
        deviceId: StoreManager.userdata.device_id,
        decision: result.kyc_result.decision,
        faceMatching: result.kyc_result.compare,
        idInfo: {...result.kyc_result.front, ...result.kyc_result.back},
          editOCR:StoreManager.appdata.editOCR,
        rawImage: StoreManager.appdata.rawImage,
        ekycResult: result,
        sdkHistories:  StoreManager.appdata.sdkHistories
      }
      StoreManager.appdata.callback(sdkResult)
      
      setTimeout(async () => {
        await  StoreManager.stopStream()
         TrueID.close()
     }, 100)


    })
    .catch((error) => console.error(error));
  }


}

export const callAPICompleteWithOCR = () => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", StoreManager.appdata.configEkyc.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  if (StoreManager.appdata.configEkyc.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configEkyc.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }

  const raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "device_id": StoreManager.userdata.device_id,
    "app_version":StoreManager.userdata.app_version,
    "os_version": StoreManager.userdata.os_version,
    "platform": StoreManager.userdata.platform,
    "pull_ekyc_result": 1,
    "id_number": StoreManager.appdata.editOCR.idNumber,
    "full_name": StoreManager.appdata.editOCR.fullName,
    "dob": StoreManager.appdata.editOCR.dateOfBirth,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };
  if(StoreManager.appdata.configEkyc.configEndpoint.complete == ""){
    let sdkResult = {
      code: 1,
      errorMessage: "",
      clientId: StoreManager.appdata.configEkyc.clientId,
      requestId: StoreManager.appdata.requestId,
      deviceId: StoreManager.userdata.device_id,
      rawImage: StoreManager.appdata.rawImage,
      sdkHistories:  StoreManager.appdata.sdkHistories,
      editOCR:StoreManager.appdata.editOCR,


    }
    StoreManager.appdata.callback(sdkResult)
    setTimeout(async () => {
     await  StoreManager.stopStream()
      TrueID.close()
  }, 100)

    return
  }

  // fetch("/api/ekyc/v1.2/complete", requestOptions)
  fetch(`${StoreManager.appdata.configEkyc.domain}${StoreManager.appdata.configEkyc.configEndpoint.complete}`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      // Helpers.loading.hideLoadingSpinner()
      // console.log("/api/ekyc/v1.2/complete", result)
      let sdkResult = {
        code: 1,
        errorMessage: "",
        clientId: result.client_id,
        requestId: result.request_id,
        deviceId: StoreManager.userdata.device_id,
        decision: result.kyc_result.decision,
        faceMatching: result.kyc_result.compare,
        idInfo: {...result.kyc_result.front, ...result.kyc_result.back},
          editOCR:StoreManager.appdata.editOCR,
        rawImage: StoreManager.appdata.rawImage,
        ekycResult: result,
        sdkHistories:  StoreManager.appdata.sdkHistories
      }
      StoreManager.appdata.callback(sdkResult)
      setTimeout(async () => {
        await  StoreManager.stopStream()
         TrueID.close()
     }, 100)

    })
    .catch((error) => console.error(error));
}


export const callAPIFaceAuthen = async (selfie, selfie2) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", StoreManager.appdata.configFaceAuthen.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  if (StoreManager.appdata.configFaceAuthen.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configFaceAuthen.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }

  var raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "transId":StoreManager.appdata.configFaceAuthen.transId,
    "personId": StoreManager.appdata.configFaceAuthen.personId,
    "faceImages": [selfie, selfie2],
    "device":{
      "model" : "device_model_web",
      "type" :  4,
      "platform":"web",
      "os_version": StoreManager.userdata.os_version,
      "sdkVersion":StoreManager.userdata.app_version,
    }
  });
  if(StoreManager.appdata.configFaceAuthen.sdkKey != ''){
    
    let nonce = getNonce(StoreManager.appdata.accessToken)
    let face1_32 = sampleString(selfie)
    let face2_32 = sampleString(selfie2)
    let signature = await generateHMAC(nonce, face1_32, face2_32)
      raw = JSON.stringify({
      "request_id": StoreManager.appdata.requestId,
      "transId": transId,
      "personId": personId,
      "faceImages": [selfie, selfie2],
      "apiVersion": "2",
      "device":{
        "model" : "device_model_web",
        "type" :  4,
        "platform":"web",
        "os_version": StoreManager.userdata.os_version,
        "sdkVersion":StoreManager.userdata.app_version,
      },
      "signature": signature,
      "nonce": nonce
    });
  }


  StoreManager.appdata.rawImage.selfie = selfie

 

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  fetch(`${StoreManager.appdata.configFaceAuthen.domain}${StoreManager.appdata.configFaceAuthen.authenEndPoint}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      // console.log(result)
      StoreManager.appdata.sdkHistories.push({
        path: StoreManager.appdata.configFaceAuthen.authenEndPoint,
        body: raw,
        result: result
      })
      if (result.result == 1) {
        StoreManager.appdata.thisSelfie.updateSuccess()
      } else {
        let error = Helpers.errorByCode(result.result)
        StoreManager.appdata.thisSelfie.updateError() 
        if(StoreManager.appdata.thisSelfie.countCallAPI >=  StoreManager.appdata.configFaceAuthen.maxRetry){
          StoreManager.appdata.callback({code: 302,errorMessage: "Trueid Locked", clientId: StoreManager.appdata.configEkyc.clientId,
                            requestId: StoreManager.appdata.requestId,
                            deviceId: StoreManager.userdata.device_id,
                            rawImage: StoreManager.appdata.rawImage,
                            sdkHistories:  StoreManager.appdata.sdkHistories})
          setTimeout(async () => {
              await  StoreManager.stopStream()
              TrueID.close()
          }, 100)
        }
      }
    })
    .catch((error) => console.error(error));
}

export const callAPIFaceEnroll = async (selfie, selfie2) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", StoreManager.appdata.configFaceEnroll.clientId);
  myHeaders.append("Authorization", `Bearer ${StoreManager.appdata.accessToken}`);
  if (StoreManager.appdata.configFaceEnroll.configHeader != "") {
    let configHeader = JSON.parse(StoreManager.appdata.configFaceEnroll.configHeader);
    Object.keys(configHeader).forEach(key => {
      myHeaders.append(key, configHeader[key]);
    });
  }

  var raw = JSON.stringify({
    "request_id": StoreManager.appdata.requestId,
    "transId":StoreManager.appdata.configFaceEnroll.transId,
    "personId": StoreManager.appdata.configFaceEnroll.personId,
    "faceImages": [selfie, selfie2],
    "nfcData":{},
    "device":{
      "model" : "device_model_web",
      "type" :  4,
      "platform":"web",
      "os_version": StoreManager.userdata.os_version,
      "sdkVersion":StoreManager.userdata.app_version,
    }
  });
  if(StoreManager.appdata.configFaceEnroll.sdkKey != ''){
    
    let nonce = getNonce(StoreManager.appdata.accessToken)
    let face1_32 = sampleString(selfie)
    let face2_32 = sampleString(selfie2)
    let signature = await generateHMAC(nonce, face1_32, face2_32)
      raw = JSON.stringify({
      "request_id": StoreManager.appdata.requestId,
      "transId": transId,
      "personId": personId,
      "faceImages": [selfie, selfie2],
      "apiVersion": "2",
      "device":{
        "model" : "device_model_web",
        "type" :  4,
        "platform":"web",
        "os_version": StoreManager.userdata.os_version,
        "sdkVersion":StoreManager.userdata.app_version,
      },
      "signature": signature,
      "nonce": nonce
    });
  }


  StoreManager.appdata.rawImage.selfie = selfie

 

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  fetch(`${StoreManager.appdata.configFaceEnroll.domain}${StoreManager.appdata.configFaceEnroll.enrollEndPoint}`, requestOptions)

    .then((response) => response.json())
    .then((result) => {
      // console.log(result)
      StoreManager.appdata.sdkHistories.push({
        path: StoreManager.appdata.configFaceEnroll.enrollEndPoint,
        body: raw,
        result: result
      })
      if (result.result == 1) {
        StoreManager.appdata.thisSelfie.updateSuccess()
      } else {
        let error = Helpers.errorByCode(result.result)
        StoreManager.appdata.thisSelfie.updateError() 
        if(StoreManager.appdata.thisSelfie.countCallAPI >=  StoreManager.appdata.configFaceEnroll.maxRetry){
          StoreManager.appdata.callback({code: 302,errorMessage: "Trueid Locked", clientId: StoreManager.appdata.configEkyc.clientId,
                            requestId: StoreManager.appdata.requestId,
                            deviceId: StoreManager.userdata.device_id,
                            rawImage: StoreManager.appdata.rawImage,
                            sdkHistories:  StoreManager.appdata.sdkHistories})
          setTimeout(async () => {
              await  StoreManager.stopStream()
              TrueID.close()
          }, 100)
        }
      }
    })
    .catch((error) => console.error(error));
}